export default "/images/vendor/flag-icon-css/flags/1x1/dm.svg?dc3455775ad035d0926ce4551bc721a6";